"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var bus_rdf_resolve_quad_pattern_1 = require("@comunica/bus-rdf-resolve-quad-pattern");

var core_1 = require("@comunica/core");

var asynciterator_1 = require("asynciterator");

var asyncreiterable_1 = require("asyncreiterable");
/**
 * A comunica Service Query Operation Actor.
 * It unwraps the SERVICE operation and executes it on the given source.
 */


var ActorQueryOperationService =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationService, _bus_query_operation_);

  function ActorQueryOperationService(args) {
    _classCallCheck(this, ActorQueryOperationService);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationService).call(this, args, 'service'));
  }

  _createClass(ActorQueryOperationService, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(pattern.name.termType !== 'NamedNode')) {
                  _context.next = 2;
                  break;
                }

                throw new Error("".concat(this.name, " can only query services by IRI, while a ").concat(pattern.name.termType, " was given."));

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var endpoint, subContext, sourceType, output;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = pattern.name.value; // Adjust our context to only have the endpoint as source

                context = context || core_1.ActionContext({});
                subContext = context.delete(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCE).delete(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES);
                sourceType = this.forceSparqlEndpoint ? 'sparql' : 'auto';
                subContext = subContext.set(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES, asyncreiterable_1.AsyncReiterableArray.fromFixedData([{
                  type: sourceType,
                  value: endpoint
                }])); // Query the source

                _context2.prev = 5;
                _context2.t0 = bus_query_operation_1.ActorQueryOperation;
                _context2.next = 9;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.input,
                  context: subContext
                });

              case 9:
                _context2.t1 = _context2.sent;
                output = _context2.t0.getSafeBindings.call(_context2.t0, _context2.t1);
                _context2.next = 20;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t2 = _context2["catch"](5);

                if (!pattern.silent) {
                  _context2.next = 19;
                  break;
                }

                // Emit a single empty binding
                output = {
                  bindingsStream: new asynciterator_1.SingletonIterator(bus_query_operation_1.Bindings({})),
                  type: 'bindings',
                  variables: []
                };
                _context2.next = 20;
                break;

              case 19:
                throw _context2.t2;

              case 20:
                return _context2.abrupt("return", output);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 13]]);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationService;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationService = ActorQueryOperationService;